import { render } from "./RemoteSelect.vue?vue&type=template&id=8fa8ee44"
import script from "./RemoteSelect.vue?vue&type=script&lang=js"
export * from "./RemoteSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QSelect});
